import { getModelById } from '../api';
import { fetchModelAssets } from './fetchModelAssets';

export const fetchModelAndAssets = async (id, setModel, setError, setAssets) => {
    var modelData = fetchModel(id, setError);
    setModel(modelData);

    try {
        const modelAssets = await fetchModelAssets(modelData);
        setAssets(modelAssets);
    } catch (err) {
        console.error('Failed to fetch model', err);
        setError('Failed to fetch model. Please try again later.');
    }
};

export const fetchModel = async (id, setError) => {
    var modelData = null;
    
    try {
        const response = await getModelById(id);
        modelData = response.data;

    } catch (err) {
        console.error('Failed to fetch model', err);
        setError('Failed to fetch model. Please try again later.');
    }

    return modelData
};